module.exports = __webpack_public_path__ + "static/l2-a6144473775ee58b8eb3dbd6bbfa822c.jpg";